<div class="prose">
  <h3>{{ 'pages.passwordReset.title' | translate }}</h3>
  <p class="mb-8">{{ 'pages.passwordReset.text' | translate }}</p>
</div>
<form class="mb-4 flex flex-col items-start gap-4" [formGroup]="form">
  <formly-form
    class="w-full"
    [model]="model"
    [fields]="fields"
    [form]="form"
    [options]="options"
  />
  @if (resetError) {
    <p data-test-id="resetError" class="text-red-600">{{ resetError }}</p>
  }
  @if (recoveryStartSuccessful) {
    <app-button
      type="primary"
      class="mt-4 w-full"
      data-test-id="retry-button"
      [disabled]="remainingCooldown !== 0"
      (trigger)="requestCode()"
    >
      {{ `Code erneut anfordern${remainingCooldown > 0 ? ' in' : ''}` }}
      <p>
        {{ remainingCooldown > 0 ? remainingCooldown : '' }}
      </p>
    </app-button>
  }
  <app-button
    type="primary"
    class="mt-4 w-full"
    data-test-id="submit-button"
    [disabled]="form.invalid"
    (trigger)="recoveryStartSuccessful ? confirmReset() : requestCode()"
  >
    {{
      (this.recoveryStartSuccessful
        ? 'pages.passwordReset.submitButton.confirmChange'
        : 'pages.passwordReset.submitButton.requestCode'
      ) | translate
    }}
    @if (loading) {
      <svg-icon
        class="animate-spin"
        src="assets/icons/General/loading-01.svg"
      />
    }
  </app-button>
</form>
<p class="self-end">
  Zurück zum
  <a class="cursor-pointer text-blue-600" [routerLink]="['/login']">Login</a>
</p>
@if (resetSuccessful) {
  <p class="mt-4 rounded-lg border border-green-200 bg-green-50 p-4">
    Die Änderung Ihres Passworts war erfolgreich. Bitte versuchen Sie sich
    erneut anzumelden.
  </p>
}
@if (recoveryStartSuccessful && !resetSuccessful) {
  <div
    class="prose prose-sm mt-4 rounded-lg border border-orange-200 bg-orange-50 p-4"
    [innerHTML]="
      'pages.passwordReset.passwordRules' | translate | markdown | async
    "
  ></div>
}
